import { Slot } from 'expo-router';
import { View } from 'react-native';

import { SLOT_CONTAINER_STYLES } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Uses `Slot` instead of `Stack` because this tab has a single screen
 * and doesn't need stack navigation. `Slot` renders the matched route
 * directly without creating an extra navigator.
 */
export default function ReorderTabLayout() {
  return (
    <View style={SLOT_CONTAINER_STYLES.container}>
      <Slot />
    </View>
  );
}
